(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceDeleteController',TreatmentExperienceDeleteController);

    TreatmentExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'TreatmentExperience'];

    function TreatmentExperienceDeleteController($uibModalInstance, entity, TreatmentExperience) {
        var vm = this;

        vm.treatmentExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TreatmentExperience.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
